<div class="job-apply-sidebar">
  <!-- Job Overview -->
  <app-card background="blue">
    <div class="job-overview">
      <h3 class="job-overview__title">{{ 'jobApply.jobOverview' | transloco }}</h3>
      <app-job-highlight-item
        icon="fa-briefcase"
        label="{{ 'job.startDate' | transloco }}"
        value="{{ job?.startDateAsap ? ('job.asap' | transloco) : job?.startDate }}"></app-job-highlight-item>
      <app-job-highlight-item icon="fa-map-marker-alt" label="{{ 'job.placeOfWork' | transloco }}" [value]="getWorkplaceTypeDisplay(job?.placeOfWork)"></app-job-highlight-item>
      <app-job-highlight-item
        icon="fa-clock"
        label="{{ 'job.employmentType' | transloco }}"
        [value]="getEmploymentTypeDisplay(job?.type)"></app-job-highlight-item>
      <app-job-highlight-item
        icon="fa-calendar"
        label="{{ 'job.practiceYears' | transloco }}"
        value="{{ job?.additionalInfo?.practiceYear || '0' }}"></app-job-highlight-item>
      <app-job-highlight-item
        icon="fa-user-graduate"
        label="{{ 'job.suitableForGraduate' | transloco }}"
        value="{{ job?.additionalInfo?.graduate ? ('common.yes' | transloco) : ('common.no' | transloco) }}"></app-job-highlight-item>
      <app-job-highlight-item
        icon="fa-euro-sign"
        label="{{ 'job.salary' | transloco }}"
        [value]="
          (job?.salary?.basicSalary || 0) +
          (job?.salary?.upperSalary ? ' - ' + job?.salary?.upperSalary : '') +
          ' ' +
          (job?.salary?.currency || '') +
          (job?.salary?.period ? ' / ' + ('jobSalaryPeriods.' + job?.salary?.period | transloco) : '')
        "></app-job-highlight-item>
    </div>
  </app-card>

  <!-- Company Info -->
  <app-card>
    <div class="card__content w-100">
      <div class="company-info-card">
        <h3 class="company-info-card__title">{{ 'jobApply.aboutCompany' | transloco }}</h3>
        <div class="company-info-card__logo">
          <img [src]="job?.tenantLogoUrl" [alt]="job?.tenantName" />
        </div>
        <h4 class="company-info-card__name">{{ job?.tenantName }}</h4>
        <p class="company-info-card__description">{{ job?.companyDescription }}</p>
        <div class="company-info-card__social">
          <a href="#" class="company-info-card__social-link" [attr.aria-label]="'aria.socialLinkedin' | transloco"><i class="fab fa-linkedin"></i></a>
          <a href="#" class="company-info-card__social-link" [attr.aria-label]="'aria.socialTwitter' | transloco"><i class="fab fa-twitter"></i></a>
          <a href="#" class="company-info-card__social-link" [attr.aria-label]="'aria.socialFacebook' | transloco"><i class="fab fa-facebook"></i></a>
          <a href="#" class="company-info-card__social-link" [attr.aria-label]="'aria.socialInstagram' | transloco"><i class="fab fa-instagram"></i></a>
        </div>
      </div>
    </div>
  </app-card>
</div>
